
import { useState } from 'react';

export default function HomePage() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nombre', formData.nombre);
      formBody.append('email', formData.email);
      formBody.append('telefono', formData.telefono);
      formBody.append('mensaje', formData.mensaje);

      const response = await fetch('https://readdy.ai/api/form/d3tf335jnnh8vq2juip0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nombre: '', email: '', telefono: '', mensaje: '' });
      } else {
        // Optional: read error details
        console.error('Submission error:', response.status, response.statusText);
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Fetch exception:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center">
                <i className="ri-heart-pulse-line text-2xl text-white"></i>
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Dra. Amor y Vida</h1>
                <p className="text-sm text-teal-600">Adriana Muñoz</p>
              </div>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a href="#inicio" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Inicio</a>
              <a href="#servicios" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Servicios</a>
              <a href="#sobre-mi" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Sobre Mí</a>
              <a href="#contacto" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Contacto</a>
              <a href="https://wa.me/526692612777" target="_blank" rel="noopener noreferrer" className="bg-teal-500 text-white px-6 py-2 rounded-full hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                Agendar Cita
              </a>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="inicio" className="relative bg-cover bg-center" style={{
        backgroundImage: `linear-gradient(rgba(20, 184, 166, 0.85), rgba(13, 148, 136, 0.85)), url('https://public.readdy.ai/ai/img_res/ac271a5e5652ce43f8127f8606eb8cb8.jpg')`
      }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
          <div className="w-full text-center text-white">
            <h2 className="text-5xl md:text-6xl font-bold mb-6">
              Recupera tu Equilibrio Emocional
            </h2>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              Soy la Psicóloga Adriana Muñoz, especialista en Regulación emocional y Somática. Te ayudo a encontrar paz y bienestar desde la comodidad de tu hogar.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a href="https://wa.me/526692612777" target="_blank" rel="noopener noreferrer" className="bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>Agenda tu Primera Sesión</span>
              </a>
              <a href="#servicios" className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                Conocer Más
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sobre Mí */}
      <section id="sobre-mi" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://static.readdy.ai/image/0507426ac8a76264b390c2066348759a/bd5611cbf4d2ce7d9a46c48106eb3913.jpeg"
                alt="Dra. Adriana Muñoz"
                className="rounded-2xl shadow-2xl w-full object-cover object-top"
              />
            </div>
            <div>
              <h3 className="text-4xl font-bold text-gray-900 mb-6">
                Psicóloga Adriana Muñoz
                <span className="block text-teal-600 text-2xl mt-2">Dra. Amor y Vida</span>
              </h3>
              <p className="text-lg text-gray-700 mb-6">
                Con 35 años de experiencia ayudando a personas a superar sus desafíos emocionales, me especializo en el tratamiento de la desregulación emocional, un problema que afecta profundamente la calidad de vida de muchas personas.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Mi enfoque terapéutico se centra en brindarte herramientas prácticas y efectivas para que puedas manejar tus emociones de manera saludable, recuperar tu bienestar y vivir una vida más plena y equilibrada.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-teal-600"></i>
                  </div>
                  <p className="text-gray-700">Atención personalizada y confidencial</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-teal-600"></i>
                  </div>
                  <p className="text-gray-700">Sesiones online por videollamada de WhatsApp</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-teal-600"></i>
                  </div>
                  <p className="text-gray-700">Enfoque práctico y orientado a resultados</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ¿Qué es la Desregulación Emocional? */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">
              ¿Qué es la Desregulación Emocional?
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Es la dificultad para manejar y controlar las emociones de manera efectiva, lo que puede afectar tu vida diaria y relaciones.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-red-50 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-emotion-unhappy-line text-3xl text-red-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">Síntomas Comunes</h4>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-red-600 mt-1"></i>
                  <span>Cambios de humor intensos y repentinos</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-red-600 mt-1"></i>
                  <span>Dificultad para calmarte cuando estás molesto</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-red-600 mt-1"></i>
                  <span>Reacciones emocionales desproporcionadas</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-red-600 mt-1"></i>
                  <span>Sensación de estar abrumado constantemente</span>
                </li>
              </ul>
            </div>
            <div className="bg-orange-50 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-emotion-sad-line text-3xl text-orange-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">Impacto en tu Vida</h4>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-orange-600 mt-1"></i>
                  <span>Problemas en relaciones personales</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-orange-600 mt-1"></i>
                  <span>Dificultades laborales o académicas</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-orange-600 mt-1"></i>
                  <span>Baja autoestima y autoconfianza</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-orange-600 mt-1"></i>
                  <span>Ansiedad y estrés constante</span>
                </li>
              </ul>
            </div>
            <div className="bg-teal-50 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-add-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">La Buena Noticia</h4>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-teal-600 mt-1"></i>
                  <span>La desregulación emocional se puede tratar</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-teal-600 mt-1"></i>
                  <span>Aprenderás técnicas efectivas de manejo</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-teal-600 mt-1"></i>
                  <span>Recuperarás el control de tu vida</span>
                </li>
                <li className="flex items-start space-x-2">
                  <i className="ri-arrow-right-s-line text-teal-600 mt-1"></i>
                  <span>Mejorarás tu bienestar general</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Servicios */}
      <section id="servicios" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">
              Cómo Puedo Ayudarte
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ofrezco terapia especializada y personalizada para ayudarte a superar tus desafíos emocionales
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-mental-health-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">Terapia Individual</h4>
              <p className="text-gray-700 mb-4">
                Sesiones personalizadas enfocadas en tus necesidades específicas, donde trabajaremos juntos para desarrollar estrategias efectivas de regulación emocional.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-emotion-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">Manejo de Ansiedad</h4>
              <p className="text-gray-700 mb-4">
                Aprende técnicas comprobadas para reducir la ansiedad, controlar los pensamientos intrusivos y recuperar la calma en tu vida diaria.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-3-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">Regulación Emocional</h4>
              <p className="text-gray-700 mb-4">
                Desarrolla habilidades para identificar, comprender y manejar tus emociones de manera saludable y constructiva.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-user-heart-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">Autoestima y Confianza</h4>
              <p className="text-gray-700 mb-4">
                Trabaja en fortalecer tu autoestima, desarrollar una imagen positiva de ti mismo y aumentar tu confianza personal.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-team-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">Relaciones Saludables</h4>
              <p className="text-gray-700 mb-4">
                Mejora tus habilidades de comunicación y aprende a establecer límites saludables en tus relaciones personales.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-sun-line text-3xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">Bienestar Integral</h4>
              <p className="text-gray-700 mb-4">
                Desarrolla un estilo de vida equilibrado que promueva tu salud mental, emocional y física de manera integral.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Beneficios */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">
              Beneficios de la Terapia Online
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Recibe atención profesional desde la comodidad y seguridad de tu hogar
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-home-heart-line text-4xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-3">Comodidad</h4>
              <p className="text-gray-600">
                Asiste a tus sesiones desde cualquier lugar donde te sientas cómodo y seguro
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-4xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-3">Flexibilidad</h4>
              <p className="text-gray-600">
                Horarios adaptados a tu disponibilidad, sin necesidad de desplazamientos
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lock-line text-4xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-3">Privacidad</h4>
              <p className="text-gray-600">
                Total confidencialidad y privacidad en cada una de tus sesiones
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-4xl text-teal-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-3">Profesionalismo</h4>
              <p className="text-gray-600">
                La misma calidad de atención que en una consulta presencial
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonios */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">
              Lo Que Dicen Mis Pacientes
            </h3>
            <p className="text-xl text-gray-600">
              Historias reales de transformación y recuperación
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h5 className="font-bold text-gray-900 mb-1">María G.</h5>
                  <div className="flex text-yellow-400">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "La Dra. Adriana me ayudó a entender y manejar mis emociones de una manera que nunca pensé posible. Ahora me siento más en control de mi vida y mis relaciones han mejorado enormemente."
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h5 className="font-bold text-gray-900 mb-1">Carlos R.</h5>
                  <div className="flex text-yellow-400">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Sufría de ansiedad constante y no sabía cómo manejarla. Las sesiones online fueron muy cómodas y efectivas. La Dra. Amor y Vida realmente cambió mi vida."
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h5 className="font-bold text-gray-900 mb-1">Laura M.</h5>
                  <div className="flex text-yellow-400">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Profesional, empática y efectiva. Me dio herramientas prácticas que uso todos los días. Recomiendo totalmente sus servicios a cualquiera que necesite apoyo emocional."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Proceso */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">
              Cómo Funciona
            </h3>
            <p className="text-xl text-gray-600">
              Comenzar tu proceso terapéutico es muy sencillo
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-500 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                1
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Contacta</h4>
              <p className="text-gray-600">
                Envíame un mensaje por WhatsApp o completa el formulario de contacto
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-500 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                2
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Agenda</h4>
              <p className="text-gray-600">
                Coordinamos un horario que se ajuste a tu disponibilidad
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-500 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                3
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Primera Sesión</h4>
              <p className="text-gray-600">
                Nos conocemos y evaluamos tus necesidades específicas
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-500 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
                4
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Comienza tu Cambio</h4>
              <p className="text-gray-600">
                Iniciamos el trabajo terapéutico hacia tu bienestar
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contacto */}
      <section id="contacto" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h3 className="text-4xl font-bold text-gray-900 mb-6">
                Agenda tu Primera Sesión
              </h3>
              <p className="text-lg text-gray-700 mb-8">
                Estoy aquí para ayudarte. Completa el formulario o contáctame directamente por WhatsApp. El primer paso hacia tu bienestar emocional comienza hoy.
              </p>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">WhatsApp</h5>
                    <a href="https://wa.me/526692612777" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 cursor-pointer">
                      +52 669 261 2777
                    </a>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">Email</h5>
                    <a href="mailto:salvatuamor2018@gmail.com" className="text-teal-600 hover:text-teal-700 cursor-pointer">
                      salvatuamor2018@gmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-video-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">Modalidad</h5>
                    <p className="text-gray-700">Videollamada por WhatsApp</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <form id="contact-form" data-readdy-form onSubmit={handleSubmit}>
                <div className="mb-6">
                  <label htmlFor="nombre" className="block text-gray-700 font-semibold mb-2">
                    Nombre Completo *
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="Tu nombre"
                  />
                </div>
                <div className="mb-6">
                  <label htmlFor="email" className="block text-gray-700 font-semibold mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="tu@email.com"
                  />
                </div>
                <div className="mb-6">
                  <label htmlFor="telefono" className="block text-gray-700 font-semibold mb-2">
                    Teléfono / WhatsApp *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="+52 123 456 7890"
                  />
                </div>
                <div className="mb-6">
                  <label htmlFor="mensaje" className="block text-gray-700 font-semibold mb-2">
                    Cuéntame brevemente cómo puedo ayudarte *
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm resize-none"
                    placeholder="Describe brevemente tu situación..."
                  ></textarea>
                  <p className="text-sm text-gray-500 mt-1">Máximo 500 caracteres</p>
                </div>
                {submitStatus === 'success' && (
                  <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-green-700 flex items-center">
                      <i className="ri-checkbox-circle-line text-xl mr-2"></i>
                      ¡Mensaje enviado! Te contactaré pronto.
                    </p>
                  </div>
                )}
                {submitStatus === 'error' && (
                  <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-red-700 flex items-center">
                      <i className="ri-error-warning-line text-xl mr-2"></i>
                      Hubo un error. Por favor intenta de nuevo.
                    </p>
                  </div>
                )}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-teal-500 text-white py-4 rounded-lg font-semibold hover:bg-teal-600 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-teal-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-4xl font-bold text-white mb-6">
            Da el Primer Paso Hacia tu Bienestar
          </h3>
          <p className="text-xl text-white mb-8">
            No tienes que enfrentar tus desafíos emocionales solo. Estoy aquí para acompañarte en tu proceso de sanación y crecimiento personal.
          </p>
          <a href="https://wa.me/526692612777" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-teal-600 px-10 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-whatsapp-line text-2xl mr-2"></i>
            Contactar Ahora
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-teal-500 rounded-full flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold">Dra. Amor y Vida</h4>
                  <p className="text-sm text-gray-400">Adriana Muñoz</p>
                </div>
              </div>
              <p className="text-gray-400">
                Psicóloga especializada en desregulación emocional. Ayudando a personas a recuperar su equilibrio y bienestar.
              </p>
            </div>
            <div>
              <h5 className="font-bold mb-4">Contacto</h5>
              <div className="space-y-3 text-gray-400">
                <p className="flex items-center">
                  <i className="ri-whatsapp-line mr-2"></i>
                  +52 669 261 2777
                </p>
                <p className="flex items-center">
                  <i className="ri-mail-line mr-2"></i>
                  salvatuamor2018@gmail.com
                </p>
                <p className="flex items-center">
                  <i className="ri-video-line mr-2"></i>
                  Videollamada WhatsApp
                </p>
              </div>
            </div>
            <div>
              <h5 className="font-bold mb-4">Enlaces Rápidos</h5>
              <div className="space-y-2">
                <a href="#inicio" className="block text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Inicio</a>
                <a href="#sobre-mi" className="block text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Sobre Mí</a>
                <a href="#servicios" className="block text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Servicios</a>
                <a href="#contacto" className="block text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">Contacto</a>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Dra. Amor y Vida - Adriana Muñoz. Todos los derechos reservados.</p>
            <p className="mt-2">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-teal-300 cursor-pointer">
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
